const { forwardRef } = require("react");

const Textarea = forwardRef(
  ({ containerClassName, className, label, message, ...props }, ref) => {
    return (
      <div className={containerClassName}>
        {label && (
          <label className="text-black-200 font-semibold text-sm mb-1 block">
            {label}
          </label>
        )}
        <div className="border border-white-300 w-full flex rounded-sm bg-white-100 transition-colors focus-within:border-primary-500 focus-within:ring-2 focus-within:ring-primary-100">
          <textarea
            ref={ref}
            className={
              "flex-1 p-3 rounded-sm focus:outline-none bg-transparent " +
              className
            }
            {...props}
          />
        </div>

        {message && (
          <span className="text-red-300 text-sm mt-1 block">{message}</span>
        )}
      </div>
    );
  }
);

export default Textarea;
